var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPageChecklistBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.5H4.5C3.94772 3.5 3.5 3.94772 3.5 4.5V19.5C3.5 20.0523 3.94772 20.5 4.5 20.5H19.5C20.0523 20.5 20.5 20.0523 20.5 19.5V4.5C20.5 3.94772 20.0523 3.5 19.5 3.5Z",
    fill: "#748FFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.5H19.5C20.0525 3.5 20.5 3.9475 20.5 4.5V6.5H3.5V4.5C3.5 3.9475 3.9475 3.5 4.5 3.5Z",
    fill: "#4C6EF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50172 10.4175C9.13478 10.4175 9.64797 9.90431 9.64797 9.27125C9.64797 8.63819 9.13478 8.125 8.50172 8.125C7.86866 8.125 7.35547 8.63819 7.35547 9.27125C7.35547 9.90431 7.86866 10.4175 8.50172 10.4175Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1405 12.875C9.29173 12.875 7.70798 12.875 6.86048 12.875C6.53298 12.875 6.28548 12.5625 6.37798 12.2475C6.64548 11.3288 7.49548 10.7125 8.50173 10.7125C9.50798 10.7125 10.3567 11.3288 10.6255 12.2475C10.718 12.5625 10.4705 12.875 10.143 12.875H10.1405Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9831 12.1293L17.7052 10.1482C17.9543 9.86167 17.9239 9.42743 17.6374 9.17832C17.3508 8.92922 16.9166 8.95959 16.6675 9.24615L14.9453 11.2273C14.6962 11.5138 14.7266 11.9481 15.0132 12.1972C15.2997 12.4463 15.734 12.4159 15.9831 12.1293Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9506 11.1916L14.8016 10.0425C14.5331 9.77402 14.0978 9.77402 13.8293 10.0425C13.5608 10.311 13.5608 10.7463 13.8293 11.0148L14.9783 12.1638C15.2468 12.4323 15.6821 12.4323 15.9506 12.1638C16.2191 11.8953 16.2191 11.46 15.9506 11.1916Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3135 16.0775H14.1885C13.8088 16.0775 13.501 16.3853 13.501 16.765C13.501 17.1447 13.8088 17.4525 14.1885 17.4525H17.3135C17.6932 17.4525 18.001 17.1447 18.001 16.765C18.001 16.3853 17.6932 16.0775 17.3135 16.0775Z",
    fill: "#BAC8FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50172 16.4962C9.13478 16.4962 9.64797 15.983 9.64797 15.35C9.64797 14.7169 9.13478 14.2037 8.50172 14.2037C7.86866 14.2037 7.35547 14.7169 7.35547 15.35C7.35547 15.983 7.86866 16.4962 8.50172 16.4962Z",
    fill: "#BAC8FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1405 18.9525C9.29173 18.9525 7.70798 18.9525 6.86048 18.9525C6.53298 18.9525 6.28548 18.64 6.37798 18.325C6.64548 17.4063 7.49548 16.79 8.50173 16.79C9.50798 16.79 10.3567 17.4063 10.6255 18.325C10.718 18.64 10.4705 18.9525 10.143 18.9525H10.1405Z",
    fill: "#BAC8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPageChecklistBlue);
export default __webpack_public_path__ + "static/media/icon_page_checklist_blue.e59be32e.svg";
export { ForwardRef as ReactComponent };